import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Common';
import Products from '../../Models/Products';
import Notifications from '../../Models/Notifications';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import { SideBar } from '../Common/SideBar';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';

class PurchaseNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productDetails: [],
            allNotifications: [],
        }
        // console.log(this.props.location.state.pro_id)
        this.getDetails(this.props.location.state.pro_id);
        this.getPurchase(this.props.location.state.id);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getDetails(id) {
        Products.getProductsDetails(id).then(res => {
            this.setState({ productDetails: res.data.product })
        })
    }

    getPurchase(id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.getPurchaseNotification(x.id, id).then(res => {
                if (res.data.payload !== null) {
                    this.setState({ allNotifications: res.data.payload })
                }
            })
        }
    }

    serviceTransaction(title) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/buyer-transaction`
                        }} className="">
                            {renderHTML(title)}
                        </Link>
                    </div>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/seller-transaction`
                        }} className="">
                            {renderHTML(title)}
                        </Link>
                    </div>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/affiliator-buyer-transaction`
                        }} className="">
                            {renderHTML(title)}
                        </Link>
                    </div>
                )
            }
        }
    }

    showSidebar() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <BuyerSidebar />
                )
            } else if (x.user_type_id === 2) {
                return (
                    <SideBar />
                )
            } else if (x.user_type_id === 3) {
                return (
                    <AffiliatorSidebar />
                )
            }
        }
    }

    render() {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        return (
            <div className="">
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    {this.showSidebar()}
                                </div>
                                <div className="col-md-8">
                                    <div className="">
                                        お知らせ
                                    </div>
                                    <hr />
                                    <div className="top_back">
                                        <table style={{ width: "100%" }}>
                                            {this.state.productDetails.map(res =>
                                                <tbody>
                                                    <tr>
                                                        <td className="invoice">
                                                            サービスID
                                                            </td>
                                                        <td style={{ width: "70%", fontSize: "12px", textAlign: "center", border: "1px solid #eee", backgroundColor: "#dfdcda" }}>
                                                            内容
                                                            </td>
                                                        <td className="invoice">
                                                            価格
                                                            </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="input_name content_dertails">
                                                            <Link to={{
                                                                pathname: `/categories-details/${res.id}`,
                                                                state: { id: res.id }
                                                            }}> {res.service_id}
                                                            </Link>
                                                            {/* {res.service_id} */}
                                                        </td>
                                                        <td className="input_name content_dertails text-left">
                                                            {this.serviceTransaction(res.title)}
                                                            {/* <Link to={{
                                                                pathname: `/categories-details/${res.id}`,
                                                                state: { id: res.id }
                                                            }}> {renderHTML(res.title)}
                                                            </Link> */}
                                                            {renderHTML(res.short_desc)}
                                                        </td>
                                                        <td className="input_name content_dertails">
                                                            ¥ {parseInt(res.price)}
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            )}
                                        </table>
                                    </div>
                                    <br />
                                    <div className="top_back">
                                        {this.state.allNotifications.notification_text}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export { PurchaseNotification }